// src/components/Footer.jsx
import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-6 py-4 text-sm text-gray-500 dark:text-gray-400">
      <div className="max-w-7xl mx-auto flex justify-center items-center">
        <span>© {new Date().getFullYear()} HelpDesk. Todos los derechos reservados.</span>
      </div>
    </footer>
  );
}
